// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1l708","label":"Category_label__3kwgI","content":"Category_content__K_m-4","header":"Category_header__mIULY","location":"Category_location__1q-xv"};